import { useState, useEffect } from 'react';
import { getCurrentTheme, getThemeAssetUrl } from 'utils/themeAssets';

const useTheme = () => {
  const [theme, setThemeState] = useState(getCurrentTheme());

  useEffect(() => {
    // Update theme if it changes externally
    const handleThemeChange = () => {
      setThemeState(getCurrentTheme());
    };

    window.addEventListener('storage', (e) => {
      if (e.key === 'bingoTheme') {
        handleThemeChange();
      }
    });

    return () => {
      window.removeEventListener('storage', handleThemeChange);
    };
  }, []);

  return {
    currentTheme: theme,
    getAssetUrl: getThemeAssetUrl,
  };
};

export default useTheme;
